import * as React from 'react';
import { useEffect } from 'react';
import Series from '../Series';
import useChart from '../UseChart';
import { jsx as _jsx } from "react/jsx-runtime";
const BarSeries = props => {
  const chart = useChart();
  useEffect(() => {
    chart.update({
      chart: {
        inverted: true
      }
    });
  }, []);
  return /*#__PURE__*/_jsx(Series, {
    ...props,
    type: "bar"
  });
};
export default BarSeries;